<div class="row container-form-list mb-4">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h6 class="card-title">Unidades de negócios adicionadas ao usuário</h6>
                <small class="card-subtitle mb-0">Adicione as unidades de negócios que o usuário {{nomeUsuario}} deve ter acesso e visibilidade</small>
            </div>
            <div class="table-responsive">
                <table class="table table-striped table-hover table-bordered">
                    <thead>
                        <tr>
                            <th class="col-delete"></th>
                            <th class="col-unidade-negocio">Unidade de Negócio</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let entity of entities; let i = index">
                            <td class="col-delete">
                                <a class="btn btn-link" (click)="delete(i)">
                                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="col-unidade-negocio">
                                <select class="form-control" name="idUnidadeNegocio_{{i}}" id="idUnidadeNegocio_{{i}}"
                                    [ngModel]="entity.idUnidadeNegocio || ''" (ngModelChange)="onChangeUnidadeNegocio(entity, $event ? $event : null)"
                                    #selectUnidadeNegocio>
                                    <option value="">Selecione a unidade de negócio...</option>
                                    <option *ngFor="let unidadeNegocio of unidadesNegocios" [ngValue]="unidadeNegocio.id">{{unidadeNegocio.nome}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr *ngIf="entities.length === 0" class="no-record">
                            <td class="text-center" colspan="2">
                                <i class='fas fa-info' aria-hidden='true'></i> Nenhum registro encontrado
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-primary btn-sm mr-2" (click)="insert()">
                    <i class="fas fa-plus" aria-hidden="true"></i> <span class="d-none d-sm-inline-block ml-1"> Adicionar unidade de negócio</span>
                </button>
                <button type="button" class="btn btn-light btn-sm" (click)="openUnidadeNegocioPopulaModal()">
                    <i class="fas fa-bolt" aria-hidden="true"></i> <span class="d-none d-sm-inline-block ml-1"> Adicionar várias unidades de negócios</span>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal para popular as unidades de negócios -->
<sgt-unidade-negocio-popula-modal
    #unidadeNegocioPopulaModal
    title="Adicionar unidades de negócios para o usuário"
    [subtitle]="getSubtitleUnidadeNegocioPopulaModal()"
    [searchByUsuarioLogado]="false"
    [entitiesAdicionadas]="entities"
    (adicionar)="onAdicionarUnidadesNegocios($event)">
</sgt-unidade-negocio-popula-modal>